import { Component, ErrorInfo, ReactNode } from "react";
import { ErrorDetails, getErrorDetails } from "@fyrstain/hl7-front-library";
import ErrorPage from "../../pages/Error/Error";

interface ApplicationErrorBoundaryProps {
    children: ReactNode;
}

interface ApplicationErrorBoundaryState {
    error?: ErrorDetails;
}

/** Displays a recoverable page instead of a blank screen after an uncaught render error. */
class ApplicationErrorBoundary extends Component<ApplicationErrorBoundaryProps, ApplicationErrorBoundaryState> {
    public state: ApplicationErrorBoundaryState = {};

    static getDerivedStateFromError(error: Error): ApplicationErrorBoundaryState {
        return { error: getErrorDetails(error) };
    }

    componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
        // Keep the complete diagnostic in the browser console without exposing it to end users.
        console.error("Unhandled application error", error, errorInfo);
    }

    render(): ReactNode {
        if (this.state.error) {
            return <ErrorPage error={this.state.error} />;
        }

        return this.props.children;
    }
}

export default ApplicationErrorBoundary;
